import { toOneDecimalPlace } from './toOneDecimalPlace';
import { Time } from '@/constants';

const { ONE_SECOND_IN_MS } = Time;

/**
 * Get the number of seconds from a number of milliseconds, rounded to one decimal place
 *
 * @param {number} milliseconds number of seconds to convert to seconds
 * @returns {number} the number of seconds, rounded to one decimal place
 */
export const getSeconds = (milliseconds: number): number =>
  toOneDecimalPlace(milliseconds / ONE_SECOND_IN_MS);
